<script setup lang="ts">
export type AnchorLinkProps = {
  anchor?: string
}

// PanelSwitcher passes the entry's own `id`, which would otherwise replace the anchor editors chose.
defineOptions({ inheritAttrs: false })

const props = defineProps<AnchorLinkProps>()
const anchorId = props.anchor
</script>

<template>
  <span class="anchor-link" data-testid="anchor-link" :id="anchorId"></span>
</template>

<style>
.anchor-link {
  display: block;
  height: 1em;
}
</style>
